import {Card, CardContent, CardDescription, CardHeader, CardTitle} from '@/components/ui/card'
import {InlineAttributeEditor} from '@/components/attributes/InlineAttributeEditor'
import {useI18n} from '@/i18n'
import {AttributeEntityType} from '@/types/attribute-entity-type'

interface ConnectorAttributesTabProps {
    connectorId: string
    canEdit: boolean
}

export function ConnectorAttributesTab({connectorId, canEdit}: ConnectorAttributesTabProps) {
    const i18n = useI18n()

    return (
        <Card>
            <CardHeader>
                <CardTitle data-testid="card-title-connector-attributes">{i18n.connectors.attributes.title}</CardTitle>
                <CardDescription>{i18n.connectors.attributes.description}</CardDescription>
            </CardHeader>
            <CardContent>
                <InlineAttributeEditor
                    entityType={AttributeEntityType.CONNECTOR}
                    entityId={connectorId}
                    canEdit={canEdit}
                />
            </CardContent>
        </Card>
    )
}
